// ═══════════════════════════════════════════════════════════════════════════════
// Previous-pairing import — full page (§0.50)
// ═══════════════════════════════════════════════════════════════════════════════

import { Navigate, useNavigate } from 'react-router-dom';
import { USER_ROLE } from '@fdh/shared';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { ImportPreviousPairingContent } from '../../components/pairing/ImportPreviousPairingContent';
import { navigateBack } from '../../lib/navigateBack';
import { SCROLL_BOTTOM_FOR_FIXED_ACTION_ROW } from '../../lib/layoutChrome';

export const ImportPreviousPairingPage = () => {
  const { user } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  if (user?.role !== USER_ROLE.EMPLOYER) {
    return <Navigate to="/home" replace />;
  }

  const handleBack = (): void => {
    navigateBack(navigate, '/dashboard');
  };

  return (
    <div className={`min-h-full bg-gray-50 dark:bg-gray-950 ${SCROLL_BOTTOM_FOR_FIXED_ACTION_ROW}`}>
      <header className="z-10 bg-white shadow-sm dark:bg-gray-900 dark:shadow-black/20">
        <div className="mx-auto max-w-lg px-4 py-4">
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={handleBack}
              aria-label={t('common.back')}
              className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-lg text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:text-gray-200 dark:hover:bg-gray-800"
            >
              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <h1 className="text-xl font-bold text-gray-900 dark:text-gray-100">
              {t('pairing.import.title')}
            </h1>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-lg px-4 py-6">
        <ImportPreviousPairingContent hideTitle />
      </main>
    </div>
  );
};
